import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AppRoutes } from "src/app/enums";
import { PRODUCT_BRAND } from "src/app/product";

/** Keeps Talk BI pages (talks, boards, data sources, onboarding) out of HouseClaw. */
export const talkBiOnlyGuard: CanActivateFn = () => {
  const brand = inject(PRODUCT_BRAND);
  const router = inject(Router);

  return brand.product === "talkbi" || router.createUrlTree([AppRoutes.realEstate]);
};
